/// <amd-module name="WidgetCommon/CommonUtils/ExtendedError" />
/** Allows for original error information to be retained with an error. */
export class ExtendedError extends Error {
    /** A payload for retaining underlying error, when exposing a user-friendly message.*/
    public extendedDiagnosticInfo: any;

    constructor(message: string, underlyingInfo: any) {
        super(message);
        this.extendedDiagnosticInfo = underlyingInfo;
    }
}
